// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


var vis = 0;
$(document).ready(function () {
  // cambio sfondo menu

  $(window).on('scroll', function () {
    var scrolltop = $(window).scrollTop();
    if (scrolltop > 100) {
      $('.top_menu').addClass('black_back');

    } else {
      $('.top_menu').removeClass('black_back');
    }

    if ($('#caratteristiche h2').visible() == true) {

      for (var i = 0; i < document.getElementsByClassName('svg-caratt').length; i++) {

        if (document.getElementsByClassName('svg-caratt')[i].contentDocument) {

          if (document.getElementsByClassName('svg-caratt')[i].contentDocument.getElementById('Livello_1')) {

            document.getElementsByClassName('svg-caratt')[i].contentDocument.getElementById('Livello_1').classList.add('start')

          }else if(document.getElementsByClassName('svg-caratt')[i].contentDocument.getElementById('svg')){

            document.getElementsByClassName('svg-caratt')[i].contentDocument.getElementById('svg').classList.add('start')

          }

        }
      }

    } else {

    }

    if ($('#tab_1').visible() == true) {
      vis++;
      if (vis == 1) {
        if (document.getElementById('tab_svg_1').contentDocument) {
          if(document.getElementById('tab_svg_1').contentDocument.getElementById('carrello')){
            if(document.getElementById('tab_svg_1').contentDocument.getElementById('freno')){
              document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s;transform:translate(0%)');
              document.getElementById('tab_svg_1').contentDocument.getElementById('freno').setAttribute('style', 'transition:all .4s; transform-origin:50% 70%; transform:translate(0%) rotate(0deg)');
                setTimeout(function () {
                  document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s ;transform:translate(-20%)');
                  setTimeout(function () {
                    document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s; transform:translate(20%)');
                    setTimeout(function () {
                      document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s;  transform:translate(0.1%)');
                      setTimeout(function () {
                        document.getElementById('tab_svg_1').contentDocument.getElementById('freno').setAttribute('style', 'transition:all .4s; transform-origin:50% 70%; transform:rotate(20deg)');
                        setTimeout(function () {
                          document.getElementById('tab_svg_1').contentDocument.getElementById('freno').setAttribute('style', 'transition:all .4s; transform-origin:50% 70%; transform:rotate(0deg)');
                        }, 420)
                      }, 420)
                    }, 420)
                  }, 420)
                }, 600)

            }else if(document.getElementById('tab_svg_1').contentDocument.getElementById('freccia')){

              document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transform:translate(-50%)');
              document.getElementById('tab_svg_1').contentDocument.getElementById('freccia').setAttribute('style', 'transform:translate(-150%)')
              document.getElementById('tab_svg_1').contentDocument.getElementById('scritta').setAttribute('style', 'opacity:0');

              setTimeout(function () {

                document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .8s; transform:translate(0%)');
                document.getElementById('tab_svg_1').contentDocument.getElementById('freccia').setAttribute('style', 'transition:all .8s; transform:translate(0%)')

                setTimeout(function () {

                  document.getElementById('tab_svg_1').contentDocument.getElementById('scritta').setAttribute('style', 'transition:all .8s; opacity:1');

                }, 850)

              }, 600)
            }else{

            }


          }else if(document.getElementById('tab_svg_1').contentDocument.getElementById('fotocamera')){
            document.getElementById('tab_svg_1').contentDocument.getElementById('fotocamera').setAttribute('style',' transform-origin: 45% 60%; transform:rotateZ(0deg)')

            setTimeout(function(){

              document.getElementById('tab_svg_1').contentDocument.getElementById('fotocamera').setAttribute('style',' transform-origin: 45% 60%; transition:all 1s; transform:rotateZ(90deg)')
              setTimeout(function(){
                document.getElementById('tab_svg_1').contentDocument.getElementById('fotocamera').setAttribute('style',' transform-origin: 45% 60%; transition:all 1s; transform:rotateZ(0deg)')

              },1020)
            },600)
          }
        }
      }
    }
  });
  // if(typeof smartsupp === 'function'){
  //   smartsupp('theme:colors', {
  //     primary:'#526FE5',
  //     banner:'#526FE5'
  //   });

  // }

  // datasheets
  if (window.location.hash == '#datasheets') {
    $('.product_menu > li > a').removeClass('current');
    $('#link_datasheets').addClass('current');
  }
  $('#link_datasheets').on('click', function () {
    $('.product_menu > li > a').removeClass('current');
    $(this).addClass('current');
  });

  // menu laterale e mobile menu
  $('#side_menu').on('click', function () {
    if (document.getElementById('mobile-menu-overlay') !== null) {
      $('#mobile-menu-overlay').toggleClass('open');
    } else {

    }
    if ($(this).hasClass('navbar-open')) {
      $(this).removeClass('navbar-open');

      $('.side_menu').animate({
        marginRight: "-30%"
      }, 1000);
    } else {
      $(this).addClass('navbar-open');
      var $target = $('html,body');
      $('.side_menu').animate({
        marginRight: 0
      }, 1000);
    }
  });

  // anteprime mega menu
  $('.product_link').on('mouseover', function () {
    var img = $(this).attr('id');
    $('.ante_img').hide();
    $('.ante_' + img).stop().fadeIn();
    $(this).parent('.column').addClass('no_back');
  });
  $('.product_link').on('mouseleave', function () {
    var img = $(this).attr('id');
    $('.ante_img').hide();
    $(this).parent('.column').removeClass('no_back');
  });

  // carosello promo
  $('.carousel_promo').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    autoplay: true,
    infinite: true,
    prevArrow: $('.promo_prev_arrow'),
    nextArrow: $('.promo_next_arrow')
  });

  // carosello prodotti
  $('.carousel_products').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    focusOnSelect: true,
    autoplay: true,
    infinite: true,
    prevArrow: $(''),
    nextArrow: $(''),
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.ric_prev_arrow'),
        nextArrow: $('.ric_next_arrow'),
      }
    }]
  });

  // carosello thumb scheda prodotto
  // $('.woocommerce_product_gallery').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   focusOnSelect: true,
  //   autoplay: true,
  //   infinite: true,
  //   dots: true,
  //   appendDots: $('.woo_dots'),
  //   prevArrow: $('.woo_prev_arrow'),
  //   nextArrow: $('.woo_next_arrow')
  // });

  altezza_prodotti();

  // scomparsa hovering video

  // tabs caratteristiche prodotto
  $('.tab').on('click', function (e) {
    e.preventDefault();
    $('.tab').removeClass('current_tab');
    $('.immagine_tab').removeClass('current_img');
    $(this).addClass('current_tab');
    var img = $(this).attr('id');
    $('.' + img).addClass('current_img');
  });

  //new tabs SVG ANIMATIOn
  if ($('#tab_1')) {
    $('#tab_1').on('click', function (e) {
      if (document.getElementById('tab_svg_1').contentDocument.getElementById('carrello')) {

        if(document.getElementById('tab_svg_1').contentDocument.getElementById('freno')){
          //smart brake
          document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s;transform:translate(0%)');
          document.getElementById('tab_svg_1').contentDocument.getElementById('freno').setAttribute('style', 'transition:all .4s; transform-origin:50% 70%; transform:translate(0%) rotate(0deg)');
          setTimeout(function () {
            document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s ;transform:translate(-20%)');
            setTimeout(function () {
              document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s; transform:translate(20%)');
              setTimeout(function () {
                document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s;  transform:translate(0.1%)');
                setTimeout(function () {
                  document.getElementById('tab_svg_1').contentDocument.getElementById('freno').setAttribute('style', 'transition:all .4s; transform-origin:50% 70%; transform:rotate(20deg)');
                  setTimeout(function () {
                    document.getElementById('tab_svg_1').contentDocument.getElementById('freno').setAttribute('style', 'transition:all .4s; transform-origin:50% 70%; transform:rotate(0deg)');
                  }, 420)
                }, 420)
              }, 420)
            }, 420)
          }, 600)
        }else if (document.getElementById('tab_svg_1').contentDocument.getElementById('freccia')){
          document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transform:translate(-50%)');
          document.getElementById('tab_svg_1').contentDocument.getElementById('freccia').setAttribute('style', 'transform:translate(-150%)')
          document.getElementById('tab_svg_1').contentDocument.getElementById('scritta').setAttribute('style', 'opacity:0');

          setTimeout(function () {
            document.getElementById('tab_svg_1').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .8s; transform:translate(0%)');
            document.getElementById('tab_svg_1').contentDocument.getElementById('freccia').setAttribute('style', 'transition:all .8s; transform:translate(0%)')
            setTimeout(function () {
              document.getElementById('tab_svg_1').contentDocument.getElementById('scritta').setAttribute('style', 'transition:all .8s; opacity:1');

            }, 850)

          }, 600)
        }
      }else if(document.getElementById('tab_svg_1').contentDocument.getElementById('piedistallo')){
        // document.getElementById('tab_svg_1').contentDocument.getElementById('freccia_tilt')
        // document.getElementById('tab_svg_1').contentDocument.getElementById('scritta')
        // document.getElementById('tab_svg_1').contentDocument.getElementById('leva')
        document.getElementById('tab_svg_1').contentDocument.getElementById('fotocamera').setAttribute('style',' transform-origin: 45% 60%;')

        setTimeout(function(){
          document.getElementById('tab_svg_1').contentDocument.getElementById('fotocamera').setAttribute('style',' transform-origin: 45% 60%; transition:all .7s; transform:rotateZ(90deg)')
          setTimeout(function(){
            document.getElementById('tab_svg_1').contentDocument.getElementById('fotocamera').setAttribute('style',' transform-origin: 45% 60%; transition:all 1s; transform:rotateZ(0deg)')

          },1000)
        },600)
      }

    })
  }

  if ($('#tab_2')) {
    $('#tab_2').on('click', function (e) {
      if (document.getElementById('tab_svg_2').contentDocument.getElementById('carrello')) {

        // default style
        if(document.getElementById('tab_svg_2').contentDocument.getElementById('freccia')){
          document.getElementById('tab_svg_2').contentDocument.getElementById('carrello').setAttribute('style', 'transform:translate(-50%)');
          document.getElementById('tab_svg_2').contentDocument.getElementById('freccia').setAttribute('style', 'transform:translate(-150%)')
          document.getElementById('tab_svg_2').contentDocument.getElementById('scritta').setAttribute('style', 'opacity:0');

          setTimeout(function () {
            document.getElementById('tab_svg_2').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .8s; transform:translate(0%)');
            document.getElementById('tab_svg_2').contentDocument.getElementById('freccia').setAttribute('style', 'transition:all .8s; transform:translate(0%)')
            setTimeout(function () {
              document.getElementById('tab_svg_2').contentDocument.getElementById('scritta').setAttribute('style', 'transition:all .8s; opacity:1');

            }, 850)

          }, 600)
        }else if( document.getElementById('tab_svg_2').contentDocument.getElementById('freno')){
          document.getElementById('tab_svg_2').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s;transform:translate(0%)');
          document.getElementById('tab_svg_2').contentDocument.getElementById('freno').setAttribute('style', 'transition:all .4s; transform-origin:50% 70%; transform:translate(0%) rotate(0deg)');
          setTimeout(function () {
            document.getElementById('tab_svg_2').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s ;transform:translate(-20%)');
            setTimeout(function () {
              document.getElementById('tab_svg_2').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s; transform:translate(20%)');
              setTimeout(function () {
                document.getElementById('tab_svg_2').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s;  transform:translate(0.1%)');
                setTimeout(function () {
                  document.getElementById('tab_svg_2').contentDocument.getElementById('freno').setAttribute('style', 'transition:all .4s; transform-origin:50% 70%; transform:rotate(20deg)');
                  setTimeout(function () {
                    document.getElementById('tab_svg_2').contentDocument.getElementById('freno').setAttribute('style', 'transition:all .4s; transform-origin:50% 70%; transform:rotate(0deg)');
                  }, 420)
                }, 420)
              }, 420)
            }, 420)
          }, 600)
        }
      }
    })
  }

  if ($('#tab_3')) {
    $('#tab_3').on('click', function (e) {
      if (document.getElementById('tab_svg_3').contentDocument.getElementById('binarioCarrello')) {
        document.getElementById('tab_svg_3').contentDocument.getElementById('piedinosx').setAttribute('style', 'transform:translate(0%)');
        document.getElementById('tab_svg_3').contentDocument.getElementById('piedinodx').setAttribute('style', 'transform:translate(0%)');

        setTimeout(function () {
          document.getElementById('tab_svg_3').contentDocument.getElementById('piedinosx').setAttribute('style', 'transition:all .4s; transform:translate(30%)');
          setTimeout(function () {
            document.getElementById('tab_svg_3').contentDocument.getElementById('piedinodx').setAttribute('style', 'transition:all .4s; transform:translate(-30%)');
            setTimeout(function () {
              document.getElementById('tab_svg_3').contentDocument.getElementById('piedinosx').setAttribute('style', 'transition:all .4s; transform:translate(0%)');
              setTimeout(function () {
                document.getElementById('tab_svg_3').contentDocument.getElementById('piedinodx').setAttribute('style', 'transition:all .4s; transform:translate(0%)');

              }, 400)
            }, 400)
          }, 400)
        }, 600)
      }else if(document.getElementById('tab_svg_3').contentDocument.getElementById('brakesx')){
        document.getElementById('tab_svg_3').contentDocument.getElementById('cm150').setAttribute('style','opacity:1');
        document.getElementById('tab_svg_3').contentDocument.getElementById('brakesx').setAttribute('style','transform:translate(-28.8%)');
        document.getElementById('tab_svg_3').contentDocument.getElementById('brakedx').setAttribute('style','transform:translate(28.8%)');
        //transform: translateX(28.8%);
        setTimeout(function () {

          document.getElementById('tab_svg_3').contentDocument.getElementById('brakesx').setAttribute('style','transition:all .4s; transform:translate(0%)');
          document.getElementById('tab_svg_3').contentDocument.getElementById('brakedx').setAttribute('style','transition:all .4s; transform:translate(0%)');
          setTimeout(function(){
            document.getElementById('tab_svg_3').contentDocument.getElementById('cm150').setAttribute('style','transition:all .4s; opacity:0');

          },400)
        }, 600)

      }
    })
  }
  if ($('#tab_4')) {
    $('#tab_4').on('click', function (e) {
      if (document.getElementById('tab_svg_4').contentDocument.getElementById('carrello')) {
        document.getElementById('tab_svg_4').contentDocument.getElementById('carrello').setAttribute('style', 'transform:translate(0%)');

        setTimeout(function () {
          document.getElementById('tab_svg_4').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s; transform:translate(30%)');
          setTimeout(function () {

            document.getElementById('tab_svg_4').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .8s; transform:translate(-30%)');
            setTimeout(function () {
              document.getElementById('tab_svg_4').contentDocument.getElementById('carrello').setAttribute('style', 'transition:all .4s; transform:translate(0.1%)');

            }, 801)
          }, 401)
        }, 401)
      }else if(document.getElementById('tab_svg_4').contentDocument.getElementById('rotella')){
        document.getElementById('tab_svg_4').contentDocument.getElementById('rotella').setAttribute('style','transform-origin:44.7% 64.7%;transform:rotate(0deg)');

        //transform: translateX(28.8%);
        setTimeout(function () {

          document.getElementById('tab_svg_4').contentDocument.getElementById('rotella').setAttribute('style','transition:all .4s; transform-origin:44.7% 64.7%;transform:rotate(-45deg)');
          setTimeout(function(){
            document.getElementById('tab_svg_4').contentDocument.getElementById('rotella').setAttribute('style','transition:all .8s; transform-origin: 44.7% 64.7%;transform:rotate(45deg)');
            setTimeout(function(){
              document.getElementById('tab_svg_4').contentDocument.getElementById('rotella').setAttribute('style','transition:all .4s;transform-origin: 44.7% 64.7%; transform:rotate(0deg)');

            },820)
          },420)
        }, 600)

      }
    })
  }

  $('#menu-item-59').on('mouseover', function (e) {
    $(this).toggleClass('current_page_item');
    $('.overlay-prod-menu').addClass('open');
    $('.mega_product_menu').stop().slideDown();
  });
  $('.mega_product_menu').on('mouseleave', function (e) {
    $('#menu-item-59').removeClass('current_page_item');
    $('.overlay-prod-menu').removeClass('open');
    $('.mega_product_menu').stop().slideUp();
  });
  $('#close_mega_product_menu').on('click', function (e) {
    $('#menu-item-59').removeClass('current_page_item');
    $('.overlay-prod-menu').removeClass('open');
    $('.mega_product_menu').slideUp();
  });
  $('.arrow_down').on('click', function (e) {
    $( "html" ).scrollTop( 600 );
  });

  /* flag/deflag checkbox su wp_contact */
  $('.privacy').find('input').on('change', function () {
    if ($(this).prop('checked'))
      $('.checkmark_contacts').addClass('checked');
    else
      $('.checkmark_contacts').removeClass('checked');
  });

  // selezione varianti prodotto
  $('.variante').on('click', function (e) {
    $('.variante').removeClass('selected');
    $(this).toggleClass('selected');
  });
  // selezione attributi prodotto con triggering variation_id
  $('.radio').on('click', function (e) {
    $(this).parent('.woocommerce-input-wrapper').find('.radio').removeClass('selected');
    $(this).toggleClass('selected');
    var for_id = $(this).attr('for');
    var radio_val = $('#' + for_id).val();
    var radio_name = $('#' + for_id).attr('name');
    $('select[name="' + radio_name + '"]').val(radio_val).trigger('change');
  });



});

// >> altezza carosello
function altezza_prodotti() {
  var altezza_carousel = $('.lista_prodotti > .col').height();
  if (!altezza_carousel)
    var altezza_carousel = $('.accessori > .col').height();
  $('.carousel_products').find('.product').height(altezza_carousel);
}

$('#btn-login').click(function () {
  $('.side_menu').animate({
    marginRight: "-30%"
  }, 1000);
});

// blocco pin
/*$('.pin').on('click', function (e) {
  e.preventDefault();
  var pin_id = $(this).attr('id');
  $('.pin_image').slideUp();
  $('#image_' + pin_id).slideDown();
  $('.pin_text').slideUp();
  $('#text_' + pin_id).slideDown();
});*/

$('.pin_image').show().animate({
  marginLeft: "-100%"
});
$('.pin').on('click', function (e) {
  e.preventDefault();
  var pin_id = $(this).attr('id');
  $('.pin_image').animate({
    marginLeft: "-100%"
  }, 500);
  $('#image_' + pin_id).animate({
    marginLeft: "0"
  }, 500);
  $('.pin_text').slideUp();
  $('#text_' + pin_id).slideDown();
});


// Zooming image

$('.woocommerce-product-gallery__image').on('click', function (e) {
  $(this).find('img').addClass('zoomImg');
});

// ajax add to cart
(function ($) {

  $(document).on('click', '.variations > .variante', function (e) {
    e.preventDefault();

    var $thisbutton = $(this),
      $form = $thisbutton.closest('form.cart'),
      id = $thisbutton.val(),
      var_id = $thisbutton.attr('id').split('_'),
      product_qty = $form.find('input[name=quantity]').val() || 1,
      product_id = $form.find('input[name=product_id]').val() || var_id,
      variation_id = var_id[1] || 0;

    var data = {
      action: 'woocommerce_ajax_add_to_cart',
      product_id: product_id,
      product_sku: '',
      quantity: product_qty,
      variation_id: variation_id,
    };

    $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

    $.ajax({
      type: 'post',
      url: wc_add_to_cart_params.ajax_url,
      data: data,
      beforeSend: function (response) {
        $thisbutton.removeClass('added').addClass('loading');
      },
      complete: function (response) {
        $thisbutton.addClass('added').removeClass('loading');
      },
      success: function (response) {

        if (response.error & response.product_url) {
          window.location = response.product_url;
          return;
        } else {
          $('.woocommerce-notices-wrapper').html('<div class="woocommerce-message-product-page" role="alert">' + response.fragments['message_text'] + '</div>');
          setTimeout(function () {
            $('.woocommerce-notices-wrapper').html('');

          }, 2000)

          $('.cart_contents_count').html(response.fragments['cart_count']);
          if(!$('.single_variation_wrap').find('.woocommerce-variation-price2').html())
            $('.single_variation_wrap').prepend('<div class="woocommerce-variation-price2"></div>');
          $('.woocommerce-variation-price2').html('<span class="price">' + response.fragments['cart_total'] + '</span><span class="tax">Tax excluded</span>');
          $('.single_add_to_cart_button').removeClass('disabled');
        }
      },
    });

    return false;
  });
})(jQuery);
$('#cross').click(function () {
  $('#cross').toggleClass('open');
  $('#shopSubMenu').toggleClass('open');
})
/*
$(document).ready(function () {

  if (document.getElementById("btn-login")) {
    var modal = document.getElementById('login-modal');
    var btn = document.getElementById("btn-login");
    var span = document.getElementsByClassName("close")[0];

    btn.onclick = function () {
      modal.style.display = "block";
    }
    span.onclick = function () {
      modal.style.display = "none";
    }
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
  }


  if (document.getElementById("btn-login-mob")) {
    var modal2 = document.getElementById('login-modal');
    var btn2 = document.getElementById("btn-login-mob");

    var span2 = document.getElementsByClassName("close")[0];

    btn2.onclick = function () {
      modal2.style.display = "block";
    }
    span2.onclick = function () {
      modal2.style.display = "none";
    }
    window.onclick = function (event) {
      if (event.target == modal2) {
        modal2.style.display = "none";
      }
    }
  }

  if (document.getElementById("login-modal-btn-head")) {
    var modal3 = document.getElementById('login-modal');
    var btn3 = document.getElementById("login-modal-btn-head");

    var span3 = document.getElementsByClassName("close")[0];

    btn3.onclick = function () {
      modal3.style.display = "block";
    }
    span3.onclick = function () {
      modal3.style.display = "none";
    }
    window.onclick = function (event) {
      if (event.target == modal3) {
        modal3.style.display = "none";
      }
    }
  }
  $('.my-paroller').paroller();
})

*/



// WEBPACK FOOTER //
// ./resources/assets/js/app.js